import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import PlugAndBarSection from "./components/PlugAndBarSection";
import ApproachSection from "./components/ApproachSection";
import PortfolioSection from "./components/PortfolioSection";
import StatsSection from "./components/StatsSection";
import TrustSection from "./components/TrustSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <PlugAndBarSection />
        <ApproachSection />
        <PortfolioSection />
        <StatsSection />
        <TrustSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}